import styled from "styled-components";
import { theme } from '../../theme'
import { styled as styledMui } from "@material-ui/core/styles"
import { Avatar, Button } from "@material-ui/core"

export const AccountTopWrapper = styled.div`
    background-color: ${({ teacher }) => (teacher ? theme.colors.teacherTheme : theme.colors.mainBlue)};
`
export const PageWrapper = styled.div`
    position: relative;
`
export const Heading = styled.div`
    color: ${theme.colors.mainBlue};
    font-weight: 700;
    font-size: 3rem;
`

export const Container = styled.div`
    margin: 0 auto;
    padding: 4rem 1rem;
    max-width: 730px;
`
export const MainContent = styled.div`
    position: relative;
    .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1.7rem;

        @media only screen and (max-width: 500px) {
            flex-direction: column-reverse;
        }
        
        .account-name {
            font-weight: 700;
            font-size: 5.1rem;
            color: ${theme.colors.mainWhite};

            @media only screen and (max-width: 326px) {
                font-size: 4.1rem;
            }
        }

        .image-container{

            
        }
    }

    .bottom {
        font-size: 1.2rem;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;

        & > div:nth-child(2) {
                text-transform: uppercase;
            }

        @media only screen and (max-width: 500px) {
            flex-direction: column;
            font-size: 1.5rem;

            & > div {
                margin: 0 auto 2rem auto;
                text-align: center;
            }
         }

        
    }
    
`

export const CustomAvatar = styledMui(Avatar)(({ theme }) => ({
    width: '10rem',
    height: '10rem',
}));

export const UploadButton = styledMui(Button)(({ theme }) => ({
    border: 0,
    // padding: 0,
    cursor: 'pointer',
    boxSizing: 'border-box',
    // display: 'inline-block',
    maxWidth: '100%',
    textAlign: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: "1.5rem",
    letterSpacing: 0,
    lineHeight: '1.6rem',
    fontWeight: 'bold',
    borderRadius: '.4rem',
    textTransform: 'uppercase',
    transition: 'all 300ms ease-in-out',
    color: theme.colors.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1.3rem 2.9rem',
    backgroundColor: theme.colors.mainBlue,
}));

export const ImageContainer = styled.div`
    width: 10rem;
    height: 10rem;
`
export const MainContentWrapper = styled.div`
background-color: ${theme.colors.grey03};
height: ${({ fullHeight }) => (fullHeight && '100%')};
`
export const ProfilePhotoSection = styled.div`
margin-top: 3rem;
 p {
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 1.6rem;
    letter-spacing: 1px;
    color: #000000;
    text-transform: uppercase;
 }

 .image-input-container {
     display: flex;
     align-items: center;
     margin-top:10px;

     @media only screen and (max-width: 564px) {
        flex-direction: column;
     }
 }
 .input-button-container {
     display:flex;
     align-items:center;
     margin-left: 26px;

     @media only screen and (max-width: 564px) {
        flex-direction: column;
        margin-left: 0px;
        margin-top:20px;
     }

     label {
         margin-left: 20px;
        @media only screen and (max-width: 564px) {
            width: 100%;
            margin-left: 0px;
        margin-top:20px;
         }
     }
 }
`

export const InputButtonContainer = styled.div`
     display:flex;
     align-items:center;

     @media only screen and (max-width: 564px) {
        flex-direction: column;
        margin-left: 0px;
        margin-top:20px;
     }

     label {
         margin-left: 20px;
        @media only screen and (max-width: 564px) {
            width: 100%;
            margin-left: 0px;
        margin-top:20px;
         }
     }
`
export const FormGrid = styled.div`
  display: grid;
    grid-template-columns: 56.4rem 1fr;
    grid-column-gap: 2.1rem;
    grid-row-gap: 2rem;

    @media only screen and (max-width: 1093px) {
        display: flex;
        flex-direction: column;
        /* margin-top:20px; */
     }
`
export const FormAction = styled.div`
    background-color: #FFFFFF;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 11px;
    padding: 9px 2px 2.1rem 2px;
    height: 16.9rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    

`